import React, { Component } from "react";
import "./ExpandableDescription.css";

/**
 * Truncates description with CSS line-clamp and toggles full text on "See More" / "See Less".
 * Keeps title and other siblings visible; only the description block expands/collapses.
 */
class ExpandableDescription extends Component {
	state = { expanded: false };

	toggle = (e) => {
		e.preventDefault();
		e.stopPropagation();
		this.setState((s) => ({ expanded: !s.expanded }));
	};

	render() {
		const {
			children,
			lines = 1,
			moreText = "See More",
			lessText = "See Less",
			className = "",
			contentClassName = "",
			anchorClassName = "show-more ml-1",
		} = this.props;
		const { expanded } = this.state;
		console.log(expanded , "expanded");

		return (
			<div className={`expandable-description ${className}`}>
				<div
					className={`expandable-description__content ${contentClassName} ${expanded ? "expandable-description__content--expanded" : "expandable-description__content--truncated"}`}
					style={expanded ? undefined : { WebkitLineClamp: lines, lineClamp: lines }}
				>
					{children}
				</div>
				<button
					type="button"
					className={`expandable-description__toggle ${anchorClassName}`}
					onClick={this.toggle}
					aria-expanded={expanded}
				>
					{expanded ? lessText : moreText}
				</button>
			</div>
		);
	}
}

export default ExpandableDescription;
